<template>
  <div id="app">
    <!-- <fire-canvas class="fire"></fire-canvas> -->
    <router-view />
  </div>
</template>

<script>
import FireCanvas   from './components/common/FireCanvas'
export default {
  data(){
    return{
    }
  },
  components:{
    FireCanvas
  },
  created(){
    console.log(window.innerHeight)
    console.log(process.env)

  },
}
</script>


<style>
#waifu{
  z-index: 2;
}
html{
  height: 100%;
}
body{
    /* min-width: 1024px; */
  margin: 0;
  padding: 0;
  height: 100%;
  position: relative;
}
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
/*#app {*/
/*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
/*-webkit-font-smoothing: antialiased;*/
/*-moz-osx-font-smoothing: grayscale;*/
/*text-align: center;*/
/*color: #2c3e50;*/
/*}*/
/*#nav {*/
/*padding: 30px;*/
/*}*/

/*#nav a {*/
/*font-weight: bold;*/
/*color: #2c3e50;*/
/*}*/

/*#nav a.router-link-exact-active {*/
/*color: #42b983;*/
/*}*/
#app {
        margin: 0;
        padding: 0;
        overflow: hidden;
        height: 100%;
    }
/* @media screen and (max-width: 1980px) {
  html{
    font-size: 20px;
  }
    }
    @media screen and (max-width: 1980px) {
  html{
    font-size: 20px;
  }
    }
    @media screen and (max-width: 1024px) {
  html{
    font-size: 10px;
  }
    } */
</style>
